import React, { createContext } from 'react';

export const TutorialContext = createContext(null);

const TutorialProvider = ({ value, children }) => (
  <TutorialContext.Provider value={value}>{children}</TutorialContext.Provider>
);

export default TutorialProvider;
